(function ($, Global) {
    var urlParams = new UrlParams();
    var params = urlParams.getParams();

    var UnesCarouselComponent = function (model) {
        this.model = model;
        this.$carousel = $('section .carousel-unes');
    };

    UnesCarouselComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    }

    UnesCarouselComponent.prototype.publishers = function () {
        var self = this;
        $(document).ready(function () {
            var paramCta = urlParams.getParam('cta');

            self.initWithEditionParam();
            self.initOwlCarousel();

            if (paramCta && typeof paramCta === "string") {
                paramCta = paramCta.replace('#', '');
            }
            
            $.Topic('carousel-unes-controls-changed').publish();

            self.initWithZenParam();

            if (paramCta && paramCta == "daily") {
                $('.btn-daily').trigger('click');
            }
        });

        $(document).on('click', '.carousel-unes .carousel-control-prev', function (e) {
            e.preventDefault();
            self.runSlideOnDirection('prev');
        });

        $(document).on('click', '.carousel-unes .carousel-control-next', function (e) {
            e.preventDefault();
            self.runSlideOnDirection('next');
        });
        $(document).on('slid.bs.carousel', '.carousel-unes', function (event) {
            $.Topic('carousel-unes-controls-changed').publish();
        });
    }

    UnesCarouselComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('change-edition').subscribe(function (date, isArchive) {
            var dateArray = date.split('/');
            var href = isArchive.toLowerCase() == 'true' ? '/archives?Issue=' + dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0] : '/daily/#/article/' + date;
            var prefix = '';

            var localPathName = window.location.pathname.toLowerCase();
            if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
            if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

            $(document).find('.ga-edition-link').attr('href', prefix+href)
            $.Topic('carousel-unes-changed').publish(date);
        });
        $.Topic('carousel-unes-controls-changed').subscribe(function () {
            self.getLabelControls();
            self.stateControls();
        });
        $.Topic('carousel-unes-changed').subscribe(function (date) {
            var $item = self.$carousel.find('.item[data-date-value="' + date + '"]');
            var itemIndex = self.$carousel.find('.carousel-inner > .item').index($item);
            var dateArray = date.split('/');
            $.Topic('loader-show').publish(self.$carousel)

            if ($item.exists()) {
                if (!$item.children().exists()) {
                    self.model.getUne({ datePublication: date },
                        function (data) {
                            $item.html(data.data.html);
                            self.$carousel.carousel(itemIndex);
                            $(window).trigger('resize');
                            $.Topic('loader-hide').publish(self.$carousel);
                            self.initOwlCarousel();
                        });
                } else {
                    self.$carousel.carousel(itemIndex);
                    $.Topic('loader-hide').publish(self.$carousel);
                    self.initOwlCarousel();
                }
                var dateText = $('.headerFrontPage #DateEdition .item[value="' + dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0] + '"] span').html()
                $('.headerFrontPage #editionSelected .date-selected').text(dateText)
            } else {
                Global.location.replace('/archives?Issue=' + dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0]);
            }
        });
    }

    UnesCarouselComponent.prototype.initWithEditionParam = function () {
        if (params['edition']) {
            var isArchive = $('#DateEdition').find('.item[value="' + params['edition'] + '"]').first().data('is-archive');
            $.Topic('change-edition').publish(params['edition'], params['archive'] ? params['archive'] : isArchive);
        }
    }
    UnesCarouselComponent.prototype.initWithZenParam = function () {
        var paramZen = urlParams.getParam('zen');
        var paramIssue = urlParams.getParam('issue');
        var prefix = '';

        var localPathName = window.location.pathname.toLowerCase();
        if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
        if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

        if (!paramZen || (paramZen == '0') || (paramZen == 'false')) {
            if (paramIssue) {
                $.Topic('carousel-unes-changed').publish(paramIssue);
            }
        } else {
            // Le numéro est spécifié dans l'URL, on renvoi vers la lecture fluide qui correspond au numéro ( le check si le num existe/est dispo est fait sur le ctrl de lecture fluide)
            if (paramIssue && paramIssue.length === 10) {
                Global.location.replace(prefix+'/daily/#/article/' + paramIssue.substring(6, 10) + "/" + paramIssue.substring(3, 5) + "/" + paramIssue.substring(0, 2));
            }
            else { //Pas de numéro spécifié dans l'URL
                Global.location.replace(prefix+'/daily');
            }
        }
    }
    UnesCarouselComponent.prototype.initOwlCarousel = function () {
        $('.even-subject .wrapper-articles').each(function () {
            $(this).owlCarousel({
                loop: false,
                nav: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        dots: true
                    },
                    680: {
                        items: $(this).find('article').length
                    }
                }
            })
        });
    }

    UnesCarouselComponent.prototype.runSlideOnDirection = function (direction) {
        var $itemActive = this.$carousel.find('.carousel-inner .item.active');
        var $nextItem = $itemActive[direction]();

        if (!$nextItem.exists()) return;

        var date = $nextItem.data('date-value');

        var isArchive = $('#DateEdition').find('.item[value="' + date + '"]').first().data('is-archive');
        $.Topic('select-edition').publish(date, isArchive)
    }

    UnesCarouselComponent.prototype.stateControls = function () {
        var isFirst = this.$carousel.find('.carousel-inner > .item:first').hasClass('active');
        var isLast = this.$carousel.find('.carousel-inner > .item:last').hasClass('active');

        this.$carousel.find('.carousel-control-prev')[isFirst ? 'addClass' : 'removeClass']('disabled');
        this.$carousel.find('.carousel-control-next')[isLast ? 'addClass' : 'removeClass']('disabled');
    }

    UnesCarouselComponent.prototype.getLabelControls = function () {
        var isFirst = this.$carousel.find('.carousel-inner > .item:first').hasClass('active');
        var isLast = this.$carousel.find('.carousel-inner > .item:last').hasClass('active');

        if (!isFirst) {
            var prevDate = this.$carousel.find('.carousel-inner > .item.active').prev().data('date-label').replace(/\//g, '.');
            this.$carousel.find('.prev-item-title .item-date').text(prevDate);
        }

        if (!isLast) {
            var nextDate = this.$carousel.find('.carousel-inner > .item.active').next().data('date-label').replace(/\//g, '.');

            this.$carousel.find('.next-item-title .item-date').text(nextDate);
        }
    }

    Global.UnesCarouselComponent = UnesCarouselComponent;
}(jQuery, window));